import React from 'react';
import {Box, Typography} from '@mui/material';

export const CopilotDisclaimer = () => (
  <Box padding={2}>
    <Typography color="#7E8986" fontSize="0.75rem" fontWeight={400}>
      AI can make mistakes! Please verify important details.
    </Typography>
  </Box>
);
